(function () {
  if (window.__sfProductShareReady) return;
  window.__sfProductShareReady = true;

  function statusFor(button, message) {
    var root = button.closest('.sf-product-share');
    var status = root && root.querySelector('[data-sf-share-status]');
    if (!status) return;
    status.textContent = message;
    window.setTimeout(function () {
      status.textContent = '';
    }, 1800);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sf-native-share]');
    if (!button) return;

    event.preventDefault();
    var url = button.getAttribute('data-share-url') || window.location.href;
    var title = button.getAttribute('data-share-title') || document.title;
    var isArabic = document.documentElement.lang.indexOf('ar') === 0;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function (error) {
        if (!error || error.name !== 'AbortError') {
          statusFor(button, isArabic ? 'تعذرت المشاركة' : 'Could not share');
        }
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        statusFor(button, isArabic ? 'تم نسخ رابط المنتج' : 'Product link copied');
      }).catch(function () {
        statusFor(button, isArabic ? 'تعذر نسخ الرابط' : 'Could not copy link');
      });
    }
  });
})();
